export default __webpack_public_path__ + "static/Dental-new-e2ada7d93f8517b82a2fc83b94d131bc.jpg";